import { Component, Event, Host, Prop, h, EventEmitter } from "@stencil/core";
import { getColorByToken } from "./../../utils/tokens";

@Component({
	tag: "smart-collapse",
	styleUrl: "smart-collapse.scss",
	shadow: true,
})

export class SmartCollapse {
	@Prop() label: string;
	@Prop() labelClosed: string;
	@Prop() direction: "up" | "down" = "down";
	@Prop({ mutable: true }) open = false;
	@Prop() iconColor?: string = "color-action-default";

	@Event() collapse: EventEmitter<boolean>;

	private toggleContent(ev: MouseEvent) {
		this.open = !this.open;
		this.collapse.emit(this.open);
		ev.stopPropagation();
	}

	render() {
		return (
			<Host part="collapse-element">
				<div class={this.direction}>
					<div role='button' class='button' onClick={(ev) => this.toggleContent(ev)}>
						<smart-text part='text-element' as='span' variant='overline'>{ this.open ? this.labelClosed : this.label }</smart-text>
						<div class='container-icon'>
							<smart-icon
								part='icon-element'
								color={getColorByToken(this.iconColor)}
								weight='bold'
								size={16}
								phosphor-icon='ph-caret-right'
							>
							</smart-icon>
						</div>
					</div>
					<div class={{ "content": true, "open": this.open }}>
						<slot></slot>
					</div>
				</div>
			</Host>
		);
	}
}
